module.exports = __webpack_public_path__ + "static/media/sync-status-banner.a3d2d100.svg";